import { Flex } from 'foundations-components/components/Flex';
import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import ErrorBoundary from '../../../components/error-boundary/ErrorBoundary';
import { APP } from '../../../constants/tracking/TrackingSources';
import LoadingCTA from '../../../features/purchaseMotions/components/LoadingCTA';
import { TalkToSalesFallback } from '../../../features/purchaseMotions/components/TalkToSalesFallback';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { upgradeProductSelector } from '../../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import CodeSplitEnvWrapper from '../../common/env/CodeSplitEnvWrapper';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotCreditsTileCTAs = ({
  screen,
  purchaseMotions,
  productConfigurations,
  location,
  trackingSource,
  productIdentifier
}) => {
  const isAppReady = useGlobalLoading();
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const widths = purchaseMotions.map(() => '100%');
  const heights = purchaseMotions.map(() => 42);
  const upgradeProduct = useAppSelector(state => upgradeProductSelector(state, {
    skuIds: productConfigurations.map(config => config.skuId)
  }));
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const sharedProps = {
    productConfigurations,
    queryParamTerm,
    trackingSource
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(TalkToSalesFallback, {
      apiName: 'hubspot-credits-committed',
      trackingSource: trackingSource,
      screen: screen
    }),
    children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !isAppReady,
      widths: widths,
      heights: heights,
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "200",
        children: purchaseMotions.map((purchaseMotion, index) => {
          return /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
              authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
              publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
              authedComponentProps: Object.assign({}, sharedProps, ctaVariantProps, {
                trackingSource,
                nonMerchandiseIdIdentifier: productIdentifier,
                skipInterstitialPage: true,
                purchaseMotionLocation: location,
                upgradeData: {
                  app: APP,
                  screen,
                  uniqueId: `${screen}-${upgradeProduct}`,
                  upgradeProduct,
                  apiName: 'hubspot-credits-committed'
                },
                use: index === 0 ? 'primary' : 'secondary',
                purchaseMotion
              }),
              publicComponentProps: Object.assign({}, sharedProps, {
                dtbSource: `pricing-page|${trackingSource}`,
                sourceId: trackingSource,
                nonMerchandiseIdProduct: productIdentifier,
                purchaseMotion,
                use: index === 0 ? 'primary' : 'secondary'
              }),
              authedComponentLoadingState: LoadingCTA,
              publicComponentLoadingState: LoadingCTA
            })
          }, purchaseMotion);
        })
      })
    })
  });
};
export default HubSpotCreditsTileCTAs;